import Typography from '@cobliteam/ui/components/Typography';

export interface BannerTextProps {
  children: React.ReactNode;
}

const BannerText = ({ children }: BannerTextProps) => (
  <Typography variant='caption-default'>{children}</Typography>
);

export default BannerText;
